import angular from 'angular';
import csmCommonWeb from 'csm-common-web';

export default angular
  .module('books.util.BooksSvc', [csmCommonWeb])
  .factory('BooksSvc', booksSvcFactory).name;

/*******************************************************************************
 * booksSvcFactory */
/**
 * Factory: BooksSvc. Contains service definitions for the BooksSvc handler.
 *******************************************************************************/
/* @ngInject */ function booksSvcFactory(CSMHttp, LocalDateSerializer) {
  var mBase = 'BooksSvc.ashx/';
  return {
    /*-------------------*/
    /* Service Endpoints */
    /*-------------------*/
    addCreditMemo: function (creditMemo) {
      return CSMHttp.doPost(mBase + 'addCreditMemo', creditMemo);
    },
    assignStatus: function (entityID, tagID) {
      return CSMHttp.doPost(mBase + 'assignStatus', {
        entityID: entityID,
        tagID: tagID
      });
    },
    billItemReferencedByCheck: function (id) {
      return CSMHttp.doPost(mBase + 'billItemReferencedByCheck', id);
    },
    bulkUpdateItemsEffectiveDates: function (itemIDs, newEffectiveDate) {
      return CSMHttp.doPost(mBase + 'bulkUpdateItemsEffectiveDates', {
        itemIDs,
        newEffectiveDate
      });
    },
    bulkDeactivateStudents: function (studentIDs) {
      return CSMHttp.doPost(mBase + 'bulkDeactivateStudents', {
        studentIDs
      });
    },
    bulkChangeTagDates: function (tagIDs, assignedAfter, assignedBefore) {
      return CSMHttp.doPost(mBase + 'bulkChangeTagDates', {
        tagIDs,
        assignedAfter,
        assignedBefore
      });
    },
    checkMenuOption: function (menuID) {
      return CSMHttp.doPost(mBase + 'checkMenuOption', { menuID: menuID });
    },
    clearStatus: function (tagID) {
      return CSMHttp.doPost(mBase + 'clearStatus', { tagID: tagID });
    },
    closePOs: function (closeDate, ids) {
      return CSMHttp.doPost(mBase + 'closePOs', {
        closeDate: closeDate,
        ids: ids
      });
    },
    downloadTextbookInformation: function (isbn) {
      return CSMHttp.doPost(mBase + 'downloadTextbookInformation', {
        isbn: isbn
      });
    },
    dropBill: function (id) {
      return CSMHttp.doPost(mBase + 'dropBill', { id: id });
    },
    //    dropCheck                   : function(id)                                                           { return CSMHttp.doPost(mBase+"dropCheck",                 { id: id }); },
    dropItemCategory: function (categoryID) {
      return CSMHttp.doPost(mBase + 'dropItemCategory', {
        categoryID: categoryID
      });
    },
    dropItemOptionMaster: function (optionID) {
      return CSMHttp.doPost(mBase + 'dropItemOptionMaster', {
        optionID: optionID
      });
    },
    //    dropReceipt                 : function(id)                                                           { return CSMHttp.doPost(mBase+"dropReceipt",               { id: id }); },
    //    dropStatement               : function(statementID)                                                  { return CSMHttp.doPost(mBase+"dropStatement",             { statementID: statementID }); },
    //    dropVoidEntry               : function(voidEntry)                                                    { return CSMHttp.doPost(mBase+"dropVoidEntry",             voidEntry); },
    findAccounts: function (name, number, activeOnly) {
      return CSMHttp.doPost(mBase + 'findAccounts', {
        name: name,
        number: number,
        activeOnly: activeOnly
      });
    },
    findAccountsByNumber: function (query) {
      return CSMHttp.doPost(mBase + 'findAccountsByNumber', {
        query: query
      });
    },
    findAddressEntities: function (name, types, activeOnly) {
      return CSMHttp.doPost(mBase + 'findAddressEntities', {
        name: name,
        types: types,
        activeOnly: activeOnly
      });
    },
    findAddressVendors: function (name, activeOnly, entityID) {
      return CSMHttp.doPost(mBase + 'findAddressVendors', {
        name: name,
        activeOnly: activeOnly,
        entityID: entityID
      });
    },
    findBills: function (filters) {
      return CSMHttp.doPost(mBase + 'findBills', filters);
    },
    findChecks: function (filters) {
      return CSMHttp.doPost(mBase + 'findChecks', filters);
    },
    findClassesByName: function (query, type) {
      return CSMHttp.doPost(mBase + 'findClassesByName', {
        query: query,
        type: type
      });
    },
    findEntities: function (name, type) {
      return CSMHttp.doPost(mBase + 'findEntities', {
        name: name,
        type: type
      });
    },
    findItemsBySKU: function (query) {
      return CSMHttp.doPost(mBase + 'findItemsBySKU', { query: query });
    },
    findReceipts: function (filters) {
      return CSMHttp.doPost(mBase + 'findReceipts', filters);
    },
    getAccount: function (accountID) {
      return CSMHttp.doPost(mBase + 'getAccount', { accountID: accountID });
    },
    getAccounts: function (exclude, types) {
      return CSMHttp.doPost(mBase + 'getAccounts', {
        exclude: exclude,
        types: types
      });
    },
    getAccountBalance: function (id) {
      return CSMHttp.doPost(mBase + 'getAccountBalance', { id: id });
    },
    getAccountGroups: function () {
      return CSMHttp.doGet(mBase + 'getAccountGroups');
    },
    getAddressEntityListItem: function (entityID) {
      return CSMHttp.doPost(mBase + 'getAddressEntityListItem', {
        entityID: entityID
      });
    },
    getBankAccounts: function (activeOnly) {
      return CSMHttp.doPost(mBase + 'getBankAccounts', {
        activeOnly: activeOnly
      });
    },
    getBill: function (id, dir) {
      return CSMHttp.doPost(mBase + 'getBill', { id: id, dir: dir });
    },
    getBillItems: function (bIDs) {
      return CSMHttp.doPost(mBase + 'getBillItems', { bIDs: bIDs });
    },
    getBulkStudents: function () {
      return CSMHttp.doPost(mBase + 'getBulkStudents');
    },
    //    getCheck                    : function(id, dir)                                                      { return CSMHttp.doPost(mBase+"getCheck",                  { id: id, dir: dir }); },
    getChecksToPrint: function (accountID) {
      return CSMHttp.doPost(mBase + 'getChecksToPrint', {
        accountID: accountID
      });
    },
    getChildSites: function () {
      return CSMHttp.doGet(mBase + 'getChildSites');
    },
    getClassInfoList: function (type, active) {
      return CSMHttp.doPost(mBase + 'getClassInfoList', {
        type: type,
        active: active
      });
    },
    //    getConstants                : function()                                                             { return CSMHttp.doGet (mBase+"getConstants"); },
    getWebConstants: function (constant) {
      return CSMHttp.doPost(mBase + 'getWebConstants', {
        constant: constant
      });
    },
    getEntity: function (id) {
      return CSMHttp.doPost(mBase + 'getEntity', { id: id });
    },
    getEntityByStudentID: function (studentID, activeOnly) {
      return CSMHttp.doPost(mBase + 'getEntityByStudentID', {
        studentID: studentID,
        activeOnly: activeOnly
      });
    },
    getEntityGroupList: function (types, activeOnly) {
      return CSMHttp.doPost(mBase + 'getEntityGroupList', {
        types: types,
        activeOnly: activeOnly
      });
    },
    getEntityIndicators: function (entityID) {
      return CSMHttp.doPost(mBase + 'getEntityIndicators', {
        entityID: entityID
      });
    },
    //    getEntityInfo               : function(entityID, type)                                               { return CSMHttp.doPost(mBase+"getEntityInfo",             { entityID: entityID, type: type }); },
    getEntityList: function (types, active) {
      return CSMHttp.doPost(mBase + 'getEntityList', {
        types: types,
        active: active
      });
    },
    getFundraiser: function (fundraiserID) {
      return CSMHttp.doPost(mBase + 'getFundraiser', {
        fundraiserID: fundraiserID
      });
    },
    getIntegrations: function () {
      return CSMHttp.doPost(mBase + 'getIntegrations');
    },
    getInventoryProducts: function (productID) {
      return CSMHttp.doPost(mBase + 'getInventoryProducts', {
        productID: productID
      });
    },
    //    getItem                     : function(type, itemID)                                                 { return CSMHttp.doPost(mBase+"getItem",                   { type: type, itemID: itemID}); },
    getItemCategory: function (categoryID) {
      return CSMHttp.doPost(mBase + 'getItemCategory', {
        categoryID: categoryID
      });
    },
    getItemCategories: function () {
      return CSMHttp.doPost(mBase + 'getItemCategories');
    },
    getItemList: function (types, categoryID, active, webStore) {
      return CSMHttp.doPost(mBase + 'getItemList', {
        types: types,
        categoryID: categoryID,
        active: active,
        webStore: webStore
      });
    },
    getItemOptionList: function (itemID) {
      return CSMHttp.doPost(mBase + 'getItemOptionList', {
        itemID: itemID
      });
    },
    getItemOptionMaster: function (optionID) {
      return CSMHttp.doPost(mBase + 'getItemOptionMaster', {
        optionID: optionID
      });
    },
    getItemOptionMasterList: function (activeOnly, includeValues) {
      return CSMHttp.doPost(mBase + 'getItemOptionMasterList', {
        activeOnly: activeOnly,
        includeValues: includeValues
      });
    },
    getNextReceiptNumbers: function () {
      return CSMHttp.doPost(mBase + 'getNextReceiptNumbers');
    },
    getOpenBills: function (entityID) {
      return CSMHttp.doPost(mBase + 'getOpenBills', { entityID: entityID });
    },
    getOrganization: function () {
      return CSMHttp.doPost(mBase + 'getOrganization');
    },
    //    getOrganizationRoles        : function()                                                             { return CSMHttp.doPost(mBase+"getOrganizationRoles"); },
    getOpenPOsFromDetail: function (ids) {
      return CSMHttp.doPost(mBase + 'getOpenPOsFromDetail', { ids: ids });
    },
    getOpenPurchaseOrders: function (entityID) {
      return CSMHttp.doPost(mBase + 'getOpenPurchaseOrders', {
        entityID: entityID
      });
    },
    getPermittedAccounts: function (userID) {
      return CSMHttp.doPost(mBase + 'getPermittedAccounts', {
        userID: userID
      });
    },
    getPOItems: function (poIDS) {
      return CSMHttp.doPost(mBase + 'getPOItems', { poIDS: poIDS });
    },
    getProductList: function (
      active,
      inventoryOnly,
      webStoreOnly,
      includeDetail
    ) {
      return CSMHttp.doPost(mBase + 'getProductList', {
        active: active,
        inventoryOnly: inventoryOnly,
        webStoreOnly: webStoreOnly,
        includeDetail: includeDetail
      });
    },
    //    getProcessorAccounts        : function()                                                             { return CSMHttp.doPost(mBase+"getProcessorAccounts"); },
    getProcessors: function () {
      return CSMHttp.doPost(mBase + 'getProcessors');
    },
    getReceipt: function (id, dir) {
      return CSMHttp.doPost(mBase + 'getReceipt', { id: id, dir: dir });
    },
    //    getStatement                : function(id)                                                           { return CSMHttp.doPost(mBase+"getStatement",              { id: id  }); },
    //    getStatementItems           : function(accountID, statementDate, statementID )                       { return CSMHttp.doPost(mBase+"getStatementItems",         { accountID: accountID, statementDate: statementDate, statementID: statementID }); },
    //    getStatementList            : function(accountID, reconciled )                                       { return CSMHttp.doPost(mBase+"getStatementList",          { accountID: accountID, reconciled: reconciled }); },
    getStoreItems: function (storeType) {
      return CSMHttp.doPost(mBase + 'getStoreItems', {
        storeType: storeType
      });
    },
    getStudent: function (id) {
      return CSMHttp.doPost(mBase + 'getStudent', { id: id });
    },
    getStudentBalance: function (entityID) {
      return CSMHttp.doPost(mBase + 'getStudentBalance', {
        entityID: entityID
      });
    },
    getTag: function (id) {
      return CSMHttp.doPost(mBase + 'getTag', { id: id });
    },
    getTaggedEntities: function (id) {
      return CSMHttp.doPost(mBase + 'getTaggedEntities', { id: id });
    },
    getTagList: function (types) {
      return CSMHttp.doPost(mBase + 'getTagList', { types: types });
    },
    getTransactionUserList: function (type) {
      return CSMHttp.doPost(mBase + 'getTransactionUserList', {
        type: type
      });
    },
    getVendor: function (id) {
      return CSMHttp.doPost(mBase + 'getVendor', { id: id });
    },
    getVendorList: function (activeOnly, restrictToOrgID) {
      return CSMHttp.doPost(mBase + 'getVendorList', {
        activeOnly: activeOnly,
        restrictToOrgID: restrictToOrgID
      });
    },
    getVendorUISettings: function () {
      return CSMHttp.doPost(mBase + 'getVendorUISettings');
    },
    //    getVoidEntry                : function(entryID)                                                      { return CSMHttp.doPost(mBase+"getVoidEntry",              { entryID: entryID }); },
    makeMember: function (entityID, memberDate) {
      return CSMHttp.doPost(mBase + 'makeMember', {
        entityID: entityID,
        memberDate: memberDate
      });
    },
    mergeEntities: function (keepID, dropIDs) {
      return CSMHttp.doPost(mBase + 'mergeEntities', {
        keepID: keepID,
        dropIDs: dropIDs
      });
    },
    processOpenOrders: function (orders) {
      return CSMHttp.doPost(mBase + 'processOpenOrders', orders);
    },
    requeueCheck: function (checkID) {
      return CSMHttp.doPost(mBase + 'requeueCheck', { checkID: checkID });
    },
    removeEntity: function (type, entityID) {
      return CSMHttp.doPost(mBase + 'removeEntity', {
        type: type,
        entityID: entityID
      });
    },
    removeEntityLogin: function (entityID) {
      return CSMHttp.doPost(mBase + 'removeEntityLogin', {
        entityID: entityID
      });
    },
    removeItem: function (type, itemID) {
      return CSMHttp.doPost(mBase + 'removeItem', {
        type: type,
        itemID: itemID
      });
    },
    removeItemOption: function (itemOptionID) {
      return CSMHttp.doPost(mBase + 'removeItemOption', {
        itemOptionID: itemOptionID
      });
    },
    removeStatus: function (entityID, tagID) {
      return CSMHttp.doPost(mBase + 'removeStatus', {
        entityID: entityID,
        tagID: tagID
      });
    },
    saveBill: function (bill) {
      return CSMHttp.doPost(mBase + 'saveBill', bill);
    },
    //    saveCheck                   : function(check)                                                        { return CSMHttp.doPost(mBase+"saveCheck",                 check); },
    saveEntity: function (entityType, entity) {
      return CSMHttp.doPost(mBase + 'saveEntity?et=' + entityType, entity);
    },
    saveEntityCredentials: function (
      entityID,
      newUserName,
      roleID,
      accts,
      expDate
    ) {
      return CSMHttp.doPost(mBase + 'saveEntityCredentials', {
        entityID: entityID,
        newUserName: newUserName,
        roleID: roleID,
        accts: accts,
        expDate: expDate
      });
    },
    saveFundraiser: function (fundraiser) {
      return CSMHttp.doPost(mBase + 'saveFundraiser', fundraiser);
    },
    saveGroup: function (groupType, group) {
      return CSMHttp.doPost(mBase + 'saveGroup?gt=' + groupType, group);
    },
    //    saveItem                    : function(item)                                                         { return CSMHttp.doPost(mBase+"saveItem",                  item); },
    saveItemCategory: function (category) {
      return CSMHttp.doPost(mBase + 'saveItemCategory', category);
    },
    saveItemOptionMaster: function (optionMaster) {
      return CSMHttp.doPost(mBase + 'saveItemOptionMaster', optionMaster);
    },
    //    saveOrganization            : function(orgInfo)                                                      { return CSMHttp.doPost(mBase+"saveOrganization",          orgInfo); },
    //    saveProcessor               : function(processor)                                                    { return CSMHttp.doPost(mBase+"saveProcessor",             processor); },
    savePurchaseOrder: function (purchaseOrder) {
      return CSMHttp.doPost(mBase + 'savePurchaseOrder', purchaseOrder);
    },
    //    saveReceipt                 : function(receipt)                                                      { return CSMHttp.doPost(mBase+"saveReceipt",               { type: receipt.type, receipt: jsonStringify(receipt)}); },
    saveStatement: function (statement) {
      return CSMHttp.doPost(mBase + 'saveStatement', statement);
    },
    saveStoreItems: function (type, items) {
      return CSMHttp.doPost(mBase + 'saveStoreItems', {
        type: type,
        items: items
      });
    },
    saveStudent: function (student) {
      return CSMHttp.doPost(mBase + 'saveStudent', student);
    },
    saveTag: function (tag) {
      return CSMHttp.doPost(mBase + 'saveTag', tag);
    },
    saveVendor: function (vendor) {
      return CSMHttp.doPost(mBase + 'saveVendor', vendor);
    },
    updateBillStatus: function (id, status) {
      return CSMHttp.doPost(mBase + 'updateBillStatus', {
        id: id,
        isPaid: status
      });
    },
    updatePOStatus: function (id, status, date) {
      return CSMHttp.doPost(mBase + 'updatePOStatus', {
        id: id,
        isClosed: status,
        closeDate: date
      });
    },
    verifyCheckNumbers: function (accountID, startCheckNum, numChecks) {
      return CSMHttp.doPost(mBase + 'verifyCheckNumbers', {
        accountID: accountID,
        startCheckNum: startCheckNum,
        numChecks: numChecks
      });
    },
    //    verifyPayPalAccount         : function(userName, password, signature, isTest)                        { return CSMHttp.doPost(mBase+"verifyPayPalAccount",       { userName: userName, password: password, signature: signature, isTest: isTest }); },
    viewAccountTypes: function () {
      return CSMHttp.doPost(mBase + 'viewAccountTypes');
    },
    viewBudgets: function () {
      return CSMHttp.doPost(mBase + 'viewBudgets');
    },
    viewChartOfAccounts: function (acctType, active) {
      return CSMHttp.doPost(mBase + 'viewChartOfAccounts', {
        acctType: acctType,
        active: active
      });
    },
    viewEntitiesForAdmin: function () {
      return CSMHttp.doPost(mBase + 'viewEntitiesForAdmin');
    },
    viewEntityCredentials: function (entityID) {
      return CSMHttp.doPost(mBase + 'viewEntityCredentials', {
        entityID: entityID
      });
    },
    viewOpenOrders: function (batchNum, receiptNum, entityID, name) {
      return CSMHttp.doPost(mBase + 'viewOpenOrders', {
        batchNum: batchNum,
        receiptNum: receiptNum,
        entityID: entityID,
        name: name
      });
    },
    viewReceivables: function (entityID, receiptID) {
      return CSMHttp.doPost(mBase + 'viewReceivables', {
        entityID: entityID,
        receiptID: receiptID
      });
    }
    //    voidCheck                   : function(voidEntry)                                                    { return CSMHttp.doPost(mBase+"voidCheck",                 voidEntry); },
    //    voidReceipt                 : function(voidEntry)                                                    { return CSMHttp.doPost(mBase+"voidReceipt",               voidEntry); }
  };
}
